export default __webpack_public_path__ + "static/media/practice-test-6.787f7e9b.csv";